/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svtag_DefenseInputs */

const en_svtag_defense = /** @type {(inputs: Svtag_DefenseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#DEFENSE`)
};

const ar_svtag_defense = /** @type {(inputs: Svtag_DefenseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#دفاع`)
};

const bn_svtag_defense = /** @type {(inputs: Svtag_DefenseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#DEFENSE`)
};

const de_svtag_defense = /** @type {(inputs: Svtag_DefenseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#DEFENSE`)
};

const es_svtag_defense = /** @type {(inputs: Svtag_DefenseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#DEFENSE`)
};

const fr_svtag_defense = /** @type {(inputs: Svtag_DefenseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#DEFENSE`)
};

const pt_svtag_defense = /** @type {(inputs: Svtag_DefenseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#DEFENSE`)
};

const zh_svtag_defense = /** @type {(inputs: Svtag_DefenseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#DEFENSE`)
};

const tr_svtag_defense = /** @type {(inputs: Svtag_DefenseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#DEFENSE`)
};

const ru_svtag_defense = /** @type {(inputs: Svtag_DefenseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#DEFENSE`)
};

const pl_svtag_defense = /** @type {(inputs: Svtag_DefenseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#DEFENSE`)
};

/**
* | output |
* | --- |
* | "#DEFENSE" |
*
* @param {Svtag_DefenseInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svtag_defense = /** @type {((inputs?: Svtag_DefenseInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svtag_DefenseInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svtag_defense(inputs)
	if (locale === "bn") return bn_svtag_defense(inputs)
	if (locale === "de") return de_svtag_defense(inputs)
	if (locale === "es") return es_svtag_defense(inputs)
	if (locale === "fr") return fr_svtag_defense(inputs)
	if (locale === "pt") return pt_svtag_defense(inputs)
	if (locale === "zh") return zh_svtag_defense(inputs)
	if (locale === "tr") return tr_svtag_defense(inputs)
	if (locale === "ru") return ru_svtag_defense(inputs)
	if (locale === "pl") return pl_svtag_defense(inputs)
	return en_svtag_defense(inputs)
});